import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert } from "../../../utils/alert";

/*
 * The registration fee paid on the public registration form, before the centre
 * exists and before it has any login. No token is sent because there is no
 * account yet.
 */

/** What the council currently charges to register. */
export const getRegisterFeeAmounts = () => async (dispatch) => {
  try {
    const response = await dispatch(getDataAPI("center/register-fee"));
    return response ? response.data.data : false;
  } catch (error) {
    // A failure here must not block registration - the form simply falls back
    // to the free flow it always had.
    return false;
  }
};

/**
 * Record a payment made on the form. Returns the fee id, which the register
 * call then sends so the payment can be attached to the new centre.
 */
export const recordRegisterFee = (data) => async (dispatch) => {
  try {
    const response = await dispatch(postDataAPI("center/register-fee", data));
    return response ? response.data.data : false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not record the payment."
    );
    return false;
  }
};
